import React, { Component, Fragment } from 'react';
import ReactGA from 'react-ga';
import {Helmet} from "react-helmet";
import NavTop from '../../containers/NavTop/NavTop';
import Link from 'react-router-dom/Link';
import ContactSection from '../../containers/ContactSection/ContactSection';
import './RemoteRxPage.css';
import { BackTop, Divider, Button, Icon } from 'antd';


class RemoteRx extends Component {

  constructor(props){
    super(props);
    ReactGA.pageview(window.location.pathname + window.location.search);
  }


  render(){ 
    return (
      <Fragment>
        <Helmet>
            <meta charSet="utf-8" />
            <title>RealTimeTouch.com - RemoteRx page</title>
            <link rel="canonical" href="http://www.realtimetouch.com/faq/" />
        </Helmet>
        <NavTop pageOn={this.props.pageOn}/>
        <BackTop />
        <div className="RemoteRx--subnavbar-container mobileoff">
          <div className="RemoteRx--subnavbar center mobileoff" >
          </div>  
          <div className="RemoteRx--subnavbar2 center mobileoff">
          </div>
          <h2 className="RemoteRx--subnavbar-headline mobileoff font-special-heading">
            <img src="https://www.realtimetouch.com/images/remoterx/PDF_32.png" alt="PDF" style={{marginRight: 4}} />Remote Rx Dispenser and Telemedicine Platform</h2>
        </div>
          <div className="RemoteRx--container center">

            <div className="RemoteRx--headline-container">
              <h2 className="RemoteRx--subheadline">World's First Remote Caregiver-controlled Rx Home Dispenser</h2>
              <h5 className="RemoteRx--body">Millions of Medical Providers and Patients will be using Telehealth solutions. Real Time Touch is strategically positioned to develop these solutions, with key intellectual property rights. Join with us in this exciting new Distributed Health human and environmental friendly development.</h5>
              {/* <h5 style={{marginTop:10}}>View some of the Frequently Asked Questions about Real Time Touch below!<br />(Click question for the answer)</h5> */}
   
              
            </div>
 
            <div style={{paddingBottom:20}}>
              <img className="RemoteRx--img" alt="Solve the $300 Billion Problem" src="https://www.realtimetouch.com/images/remoterx/solve-problem.png" />
            </div>
            <div style={{paddingBottom:40, width:400, margin:'0 auto'}}>
              <h5>Studies estimate medication nonadherence, nonoptimized medication therapy and resulting hospitalizations <b>may cost $300+ billion in the US alone and even more worldwide</b>. </h5>
            </div>            
            <div style={{paddingBottom:10}}>
              <img className="RemoteRx--img" alt="Remote Rx Dispenser and Telemedicine Platform" src="https://www.realtimetouch.com/images/remoterx/dispenser-phone-text2.jpg" />
            </div>

            <Divider style={{width:'50%', margin:'20px auto'}}/>   

            
            <div style={{width:'100%'}}>
                <h3>Read More in our full brochure... </h3>
                <Link to="/contactremoterx/">
                  <Button size="large" type="primary">
                    <img src="https://www.realtimetouch.com/images/remoterx/PDF_32.png" style={{marginRight: 4}} alt="PDF" />Get the Full Brochure<Icon type="caret-right" /></Button>
                </Link>
              </div>

             <Divider style={{width:'50%', margin:'20px auto'}}/>    

            <div class="RemoteRx--body-list">
              <h3>Big Problems to Solve, Potential to Save Billions</h3>
              <p style={{fontSize: '1.2em'}}>
              Lack of Medication Adherence is estimated to be costing <u>$300 billion+</u> (in the U.S. alone!) in increased burden to the medical system due to:
              </p>
              <ul>
                <li> Patients not taking medications as prescribed.</li> 
                <li> Missed doses due to scheduling confusion.</li> 
                <li> Emergency room visits due to avoidable errors.</li> 
                <li> Misunderstood dosages reducing efficacy.</li> 
                <li> Inconvenience of adhering to scheduled doses.</li> 
                <li> Medical advice requires waiting & travel. </li> 
                <li> Drug dependency & abuse of opioids and other drugs. </li> 
                <li> Medical providers not be aware of missed doses.</li>
              </ul>

              
            <Divider style={{width:'50%', margin:'20px auto'}}/>   

                <h3>We're developing solutions that can:</h3>
                <ul>
                  <li> Save money for patients, caregivers, hospitals, insurance and government</li> 
                  <li> Promote better health and lives for seniors and those in need who rely on medication.</li> 
                  <li> Help Seniors to stay both socially-connected and independent while getting the treatments they need.</li> 
                </ul>

            </div>
            

            <Divider style={{width:'50%', margin:'20px auto'}}/>   

            <div style={{width:'100%'}}>
              <h3>Read More in our full brochure... </h3>
              <Link to="/contactremoterx/">
                  <Button size="large" type="primary">
                    <img src="https://www.realtimetouch.com/images/remoterx/PDF_32.png" alt="PDF" style={{marginRight: 4}} />Get the Full Brochure<Icon type="caret-right" /></Button>
                </Link>
            </div>

            <Divider style={{width:'50%', margin:'20px auto'}}/>   

            <div class="RemoteRx--body-list">
              <h3>How Real Time Touch Helps Solve the Problem</h3>
              <h4>Real Time Touch Remote Rx Dispenser Features</h4>
              <p style={{fontSize: '1.2em'}}>
              Real Time Touch telemedicine platform Rx Dispenser planned features include:
              </p>

            <div style={{padding:20}}>
              <img className="RemoteRx--img img-rounded" alt="Remote Rx with Doctor" src="https://www.realtimetouch.com/images/remoterx/dispenser-phone-dr.jpg" />
            </div>


              <ul>
                <li> <b>Automatic timed release</b> with sound/light/voice reminders and 
alarms to 3rd parties when pills not taken.</li> 
                <li>Can be integrated seamlessly with other platforms that <b>monitor vitals, activity and sleep.</b></li>
                <li> <b>Security Levels</b> (multiple) for patient, medical providers and caregivers 
allowing remote locking/unlocking by user role.</li> 
                <li> Use with various interface devices (smartphone, tablet, PC or TV) -- or manually without remote from the dispenser interface</li> 
                <li> <b>AI coaching, Alexa-like voice activation</b> and voice/gesture recognition.</li> 
                <li> <b>Sensor, dosage results</b> and other data can be tracked, communicated
 and analyzed remotely for alerts, efficacy, and improving health outcomes.</li> 
                <li> eHealth tool extensibility: <b>3rd-party APIs and tools</b> (hardware and software) can be activated. </li> 
                <li> Prevents re-admissions by <b>alerting Medical providers</b> of problems.</li> 
                <li> Seniors can be both socially-connected and independent.</li>
              </ul>

            

            </div>

            <Divider style={{width:'50%', margin:'20px auto'}}/>   

              <div style={{width:'100%'}}>
                <h3>Read More in our full brochure... </h3>
                <Link to="/contactremoterx/">
                  <Button size="large" type="primary">
                  <img src="https://www.realtimetouch.com/images/remoterx/PDF_32.png" alt="PDF" style={{marginRight: 4}} />Get the Full Brochure<Icon type="caret-right" /></Button>
                </Link>
              </div>
            
            <Divider style={{width:'50%', margin:'20px auto'}}/> 

            <div style={{padding:20}}>
              <img className="RemoteRx--img" alt="Remote Rx Dispenser and Telemedicine Platform" src="https://www.realtimetouch.com/images/remoterx/dispenser-phone-text2.jpg" />
            </div>

            <div class="RemoteRx--disclaimer">
            <p>Disclaimer: This informational document is to get feedback on future business/product ideas, not a solicitation for 
investment and should not be relied on for investment purposes. Scenarios, financial & technology projections & product features 
discussed are speculative, and may not occur. Statistics cited are estimates that may be unverified from 3rd-parties. Results,
revenues, costs are not guaranteed & subject to substantial change/risks. Patents may expire before licensing. Pending patent
applications may not be granted. Success is contingent on further investments, product development, licensing and/or partnerships.</p>
           
            </div>

            {/* <ContactSection background="none"/> */}

          </div>
        </Fragment>
    )
  }
}
 
 
 export default RemoteRx;


// WEBPACK FOOTER //
// ./src/pages/RemoteRxPage/RemoteRxPage.js